var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moleculeSubMenu)?_c('div',{staticClass:"m-edition-section-content-info"},[_c(_vm.moleculeSubMenu,{tag:"MoleculeEditionSectionContentSubMenu"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }